import React from "react";
import { styled } from "@mui/material/styles";
import { InternalStandardProps, Menu, MenuProps } from "@mui/material";

const StyledMenu = styled(Menu)(({ theme }) => ({
    "& .MuiPaper-root": {
        backgroundColor: `${theme.palette.background.default} !important`,
        color: `${theme.palette.grey[600]} !important`,
    },
}));

export interface AppMenuListingProps extends InternalStandardProps<MenuProps> {
    id: string;
    anchorEl: Element | (() => Element);
    open: boolean;
    onClose: () => void;
    children: React.ReactNode;
}

export const AppMenuListing = (props: AppMenuListingProps) => {
    const { id, anchorEl, open, onClose, children, ...rest } = props;

    return (
        <StyledMenu
            id={id}
            anchorEl={anchorEl}
            open={open}
            onClose={onClose}
            {...rest}
        >
            {children}
        </StyledMenu>
    );
};
